<h2 mat-dialog-title>Branding in Progress</h2>
<mat-dialog-content class="progress-container">
  <div class="status">
    <h3>Branding Settings saved successfully!</h3>
    <h3>You have {{ total }} images to process.</h3>
    <hr>
    <div *ngIf="progressStatus !== 'done'" class="spinner"></div>
    <span *ngIf="progressStatus !== 'done'">
      {{ processed }} processed, {{ skipped }} skipped / {{ total }} images ({{ progress }}%)
    </span>
    <span *ngIf="progressStatus === 'done'" class="done-text">
      ✅ Branding complete! {{ processed }} processed, {{ skipped }} skipped / {{ total }} images
    </span>
  </div>
  
  <div class="progress-wrapper">
    <div class="progress-bar" [style.width.%]="progress"></div>
  </div>
  <!-- <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar> -->
</mat-dialog-content>

<!-- Removed close button as branding cannot be stopped once started -->
<!-- <mat-dialog-actions align="center">
  <button mat-raised-button class="save-btn" (click)="dialogRef.close()">
    Close
  </button>
</mat-dialog-actions> -->